import ComponentTypes from "./componentTypes";
import { CMSStandaloneImage } from "./components/media/CMSStandaloneMedia";
import { CMSTeasers } from "./components/CMSTeaserContainer/CMSTeasers";
import CMSTeaser from "./components/CMSTeaser/CMSTeaser";
import { CMSBanner } from "./components/CMSBanner";
import { CMSRotatingBanners } from "./components/CMSRotatingBanners";
import { CMSFilterableTileContainer } from "./components/CMSFilterableTileContainer/CMSFilterableTileContainer";
import { CMSButton, type CMSComponentProps, CMSLink, CMSList, CMSParagraph, CMSSection } from "./components/CMSSection";
import { CMSLoginCall } from "./components/CMSLoginCall";
import { CMSQuote } from "./components/CMSQuote";
import { CMSColumnContainer } from "~/CMSComponents/components/CMSColumnContainer/CMSColumnContainer";
import { CMSColumn } from "~/CMSComponents/components/CMSColumnContainer/CMSColumn";
import { CMSAccordionContainer } from "~/CMSComponents/components/CMSAccordionContainer/CMSAccordionContainer";
import { CMSAccordion } from "~/CMSComponents/components/CMSAccordion/CMSAccordion";
import { CMSPageNavigation } from "~/CMSComponents/components/CMSPageNavigation";
import { CMSNewsletterConsent } from "~/CMSComponents/components/CMSNewsletterConsent";
import { CMSPhoto } from "./components/CMSImage/CMSImage";
import { CMSPhotoGallery } from "./components/CMSPhotoGallery/CMSPhotoGallery";
import type { ComponentType } from "react";
import { CMSColumnLinks } from "./components/CMSColumnLinks/CMSColumnLinks";
import { EwellixPageNavigationComponent } from "~/CMSComponents/components/EwellixPageNavigationComponent/EwellixPageNavigationComponent";
import { CMSTable } from "~/CMSComponents/components/CMSTable/CMSTable";

const COMPONENT_MAP: {
  [K in CMSComponentProps["type"]]: ComponentType<Extract<CMSComponentProps, { type: K }>>;
} = {
  [ComponentTypes.CMSSection]: CMSSection,
  [ComponentTypes.CMSStandaloneMedia]: CMSStandaloneImage,
  [ComponentTypes.CMSList]: CMSList,
  [ComponentTypes.CMSButton]: CMSButton,
  [ComponentTypes.CMSLink]: CMSLink,
  [ComponentTypes.CMSTeaserContainer]: CMSTeasers,
  [ComponentTypes.CMSTeaser]: CMSTeaser,
  [ComponentTypes.CMSPublicationTeaser]: CMSTeaser,
  [ComponentTypes.CMSBanner]: CMSBanner,
  [ComponentTypes.CMSRotatingBanners]: CMSRotatingBanners,
  [ComponentTypes.CMSFilterableTileContainer]: CMSFilterableTileContainer,
  [ComponentTypes.CMSParagraph]: CMSParagraph,
  [ComponentTypes.CMSLoginCall]: CMSLoginCall,
  [ComponentTypes.CMSQuote]: CMSQuote,
  [ComponentTypes.CMSColumnsContainer]: CMSColumnContainer,
  [ComponentTypes.CMSColumn]: CMSColumn,
  [ComponentTypes.CMSAccordionContainer]: CMSAccordionContainer,
  [ComponentTypes.CMSAccordion]: CMSAccordion,
  [ComponentTypes.CMSTable]: CMSTable,
  [ComponentTypes.CMSPageNavigation]: CMSPageNavigation,
  [ComponentTypes.CMSNewsLetterConsent]: CMSNewsletterConsent,
  [ComponentTypes.CMSPhotoGallery]: CMSPhotoGallery,
  [ComponentTypes.CMSPhoto]: CMSPhoto,
  [ComponentTypes.CMSColumnLinks]: CMSColumnLinks,
  [ComponentTypes.EwellixPageNavigation]: EwellixPageNavigationComponent,
} as const;

export const renderCMSComponent = (props: CMSComponentProps, className?: string, key?: number): null | JSX.Element => {
  const Component = COMPONENT_MAP[props.type];

  if (!Component) {
    console.error(`Could not find a component for type ${props.type}`);
    return null;
  }

  // @ts-ignore
  return <Component key={key} className={className} {...props} />;
};

// Exports to jsp
export const createCMSComponent = (json: string) => {
  if (!json || !json.length) {
    if (import.meta.env.DEV) {
      console.warn(`CMSComponent json string is invalid`, json);
    }
    return;
  }

  const props: CMSComponentProps = JSON.parse(json);
  const element = renderCMSComponent(props);
  if (!element) {
    console.error(`Could not create a CMS component for type ${props.type}`);
    return null;
  }
  return element;
};
